import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToolbarDropdownMenu } from '@wordpress/components';
import { __, sprintf } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import LevelIcon from './level-icon';
export default function LevelControl(_ref) {
  let {
    level,
    onChange
  } = _ref;
  const allControls = [1, 2, 3, 4, 5, 6, 0].map(currentLevel => {
    const isActive = currentLevel === level;
    return {
      icon: createElement(LevelIcon, {
        level: currentLevel,
        isPressed: isActive
      }),
      title: currentLevel === 0 ? __('Paragraph') : // translators: %s: heading level e.g: "1", "2", "3"
      sprintf(__('Heading %d'), currentLevel),
      isActive,
      onClick: () => onChange(currentLevel)
    };
  });
  return createElement(ToolbarDropdownMenu, {
    label: __('Change heading level'),
    icon: createElement(LevelIcon, {
      level: level
    }),
    controls: allControls
  });
}
//# sourceMappingURL=level-toolbar.js.map